export const onlyChangedValues = <IValues>(values: IValues, initialValues: IValues): Partial<IValues> => {
  const changedFields: Partial<IValues> = {};
  for (const field in values) {
    if (values[field] !== null && values[field] !== "") changedFields[field] = values[field];
    if (values[field] !== initialValues[field]) changedFields[field] = values[field];
  }
  return changedFields;
};

export const sortElementsByOrder = <T>(elemArray: T[]): T[] => {
  if (elemArray) {
    return elemArray.sort((one: any, two: any) => {
      return one["order"] - two["order"];
    });
  }
  return [];
};

// export const

export const insertInArray = (arr: any[], index: number, newItem: any[]) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted item
  newItem,
  // part of the array after the specified index
  ...arr.slice(index)
];

// export const questionFilter = (
//   questions: IQuestion[],
//   filter: string
// ): IQuestion[] => {
//   if (filter === "none") return questions;

//   const filteredSurvey: IQuestion[] = questions.filter(
//     (question: IQuestion) => {
//       if (filter === "answered") {
//         if (
//           question.value.length !== 0 &&
//           !question.filters.includes("answered") //TODO move this code to reducer 65-75
//         ) {
//           const filteredFilters: string[] = question.filters.filter(
//             (status: string) => status !== "unanswered"
//           );
//           question.filters = [];
//           question.filters.push("answered", "new_answer", ...filteredFilters);
//         }
//       }
//       return question.filters.find((status: string) => status === filter);
//     }
//   );
//   return filteredSurvey;
// };
